import { defineComponent } from 'vue';
import ProductConfigurator from '~/components/ProductConfigurator.vue';
import Summary from '~/components/Summary.vue';
import Catalog from '~/components/Catalog.vue';
import FullscreenSpinner from '~/components/FullscreenSpinner.vue';
import { tradeAreaClient } from '~/lib/client';
import { store } from '~/store';
export default defineComponent({
    name: 'Home',
    components: {
        ProductConfigurator,
        Summary,
        Catalog,
        FullscreenSpinner,
    },
    data() {
        return {
            summaryOpen: false,
            selectedProduct: null,
            selectedProject: null,
        };
    },
    computed: {
        spinning() {
            return store.state.spinning;
        }
    },
    methods: {
        selectProduct(product) {
            console.log('Product:', product);
            this.selectedProduct = product;
            this.summaryOpen = false;
        },
        async updateProject(project) {
            console.log('Updating project', project);
            store.commit('setSpinner', true);
            this.selectedProject = project;
            this.selectedProduct = null;
            await tradeAreaClient.updateProject(project.id, this.selectedProject);
            store.commit('setSpinner', false);
            this.summaryOpen = true;
        },
    },
});
